import { createFileRoute } from '@tanstack/react-router';
import { Button } from '../components';

export const Route = createFileRoute('/testErrors')({
  component: TestErrors,
});

function TestErrors() {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-stone-100">
      <img
        src="https://storage.googleapis.com/mideoid-console-public/logos/MIDEOhealth.png"
        alt="mideo_logo"
        className="h-36"
      />
      {/* <Button id="nav-login" type="button" textContent="Go to Login Page" onClick={handleLoginClick} /> */}
      <Button
        id="nav-enroll"
        type="button"
        textContent="Break the app"
        onClick={() => {
          throw new Error(
            'Testing release based error boundaries from unauthenticated user with GitHub Action inactive',
          );
        }}
      />
    </div>
  );
}
